import { createAvatar } from '@dicebear/core';
import { openPeeps } from '@dicebear/collection';

/**
 * Open Peeps by Pablo Stanley (CC0), rendered locally by DiceBear — no avatar
 * service, no outbound request, and the same seed always draws the same face.
 * Signed-in people carry a seed they can reroll; guests are seeded by their
 * connection id, so their face is stable for as long as they are on the map.
 */
const cache = new Map();

export function avatarUri(person) {
  const seed = person?.seed || person?.username || 'anonymous';
  const color = (person?.color || '#64748b').replace('#', '');
  const key = `${seed}|${color}`;

  let uri = cache.get(key);
  if (!uri) {
    uri = createAvatar(openPeeps, {
      seed,
      size: 96,
      radius: 50,
      backgroundColor: [color],
      backgroundType: ['solid'],
    }).toDataUri();
    if (cache.size > 500) cache.clear();
    cache.set(key, uri);
  }
  return uri;
}

export const randomSeed = () => Math.random().toString(36).slice(2, 10);
